import Ajax from '../ajax'

export default {
  login: (data) => Ajax('post', 'account/login', data),
  logout: () => Ajax('get', 'account/logout'),
  register: (data) => Ajax('post', 'account/register', data),
  updatePassword: (params) => Ajax('post', 'account/updatePwd', params, 'params'),
  rewardLog: (params) => Ajax('get', 'account/rewardLog', params),
  capitalLog: () => Ajax('get', `account/capitalLog`)
}
